module.exports = __webpack_public_path__ + "static/media/img_high_potential_03.faa92309.png";